var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",on:{"click":_vm.closeSettings}},[_c('LotteryView',{ref:"lottery"}),_c('GathererLink'),_c('Navigation',{on:{"startSpin":_vm.spin}}),_c('SettingsBubble',{attrs:{"visible":_vm.$root.$data.settingsOpen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }